import { Button, Icon } from 'antd'

const AddNewButton = ({ onClick, label, isLoading, isDisable }) => {
  return (
    <Button onClick={() => onClick()} disabled={isDisable} loading={isLoading} className="p-button-create-action">
      <Icon type="plus" />
      {label}
    </Button>
  )
}

export default AddNewButton
